globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};

appCustomerSpace.Controllers.Public.WelcomeEmailSignatureBuilderController = (function (superClass) {

  utils.extend(WelcomeEmailSignatureBuilderController, superClass);

  function WelcomeEmailSignatureBuilderController() {
    return WelcomeEmailSignatureBuilderController.__super__.constructor.apply(this, arguments);
  }

  $.extend(WelcomeEmailSignatureBuilderController.prototype, {
    init: function () {
      return WelcomeEmailSignatureBuilderController.__super__.init.apply(this, arguments);
    },
    init_editor: function () {
      this._init_tabs();
      this._init_form();
    },
    _init_tabs: function () {
      var controller = this;

      $('[data-target-tab]').on('click', function (e) {
        var targetTab = $(this).data('target-tab');
        controller._active_tab(targetTab);
        e.preventDefault();
        return false;
      })
    },
    _active_tab: function (tab) {
      var $liTab = $(`.nav li[data-target-tab=${tab}]`),
        $tab = $(`.tab[data-name=${tab}]`);

      if ($liTab.hasClass('active')) return;
      if (!$tab.length) return;

      $('.nav li.active').removeClass('active');
      $(`.tab.active`).removeClass('active');

      $liTab.addClass('active');
      $tab.addClass('active');

      this._adjustMobileSignature();
    },
    _init_form: function () {
      var controller = this;

      controller.$form = $('form');
      controller.$template_selection = controller.$form.find('.template-selection');

      controller.$form.find('.save-editor-onchange').on('change', function () {
        controller._save();
      });

      controller.$template_selection.on('click', '.set-template', function () {
        controller._setTemplate($(this).data('value'));
      });

      controller.$template_selection.on('click', '.prev-template', function () {
        controller._prevTemplate();
        return false;
      });

      controller.$template_selection.on('click', '.next-template', function () {
        controller._nextTemplate();
        return false;
      });

      controller._adjustMobileSignature();
      $(window).resize(function () {
        controller._adjustMobileSignature()
      });
    },
    _setTemplate: function (value) {
      var $input = this.$template_selection.find('input');

      if ($input.val() != value) {
        this.$template_selection.find('.template-item.active').removeClass('active');

        var $selectedTemplate = this.$template_selection.find(`.template-item[data-value="${value}"]`);
        $selectedTemplate.addClass('active');

        if ($selectedTemplate.is(this.$template_selection.find('.template-item').first())) {
          this.$template_selection.find('.prev-template').hide();
          this.$template_selection.find('.next-template').show();
        } else if ($selectedTemplate.is(this.$template_selection.find('.template-item').last())) {
          this.$template_selection.find('.prev-template').show();
          this.$template_selection.find('.next-template').hide();
        } else {
          this.$template_selection.find('.prev-template').show();
          this.$template_selection.find('.next-template').show();
        }

        $input.val(value).trigger('change');
      }
    },
    _nextTemplate: function () {
      this.$template_selection.find('.template-item.active').next().trigger('click');
    },
    _prevTemplate: function () {
      this.$template_selection.find('.template-item.active').prev().trigger('click');
    },
    _adjustMobileSignature() {
      var containerWidth = $(window).width() - 100;
      let tableWidth = this.$template_selection.find('.mobile .signature').width();
      let scale = containerWidth / tableWidth;

      if (scale > 1) scale = 1;
      if (scale < 0.5) scale = 0.5;

      this.$template_selection.find('.email-window').css('width', $(window).width() - 40)

      this.$template_selection.find('.mobile .signature').css({
        'transform': 'scale(' + scale + ')',
        'transform-origin': 'top left',
        'display': 'inline-block'
      });
    },
    _save: function () {
      var controller = this;
      $('.signature').addClass('saving');

      $.ajax({
        url: controller.$form.attr('action'),
        method: controller.$form.attr('method'),
        data: new FormData(controller.$form[0]),
        contentType: false,
        processData: false,
        success: function (data) {
          if (data.response) {
            if (data.template) {
              $('.signature').removeClass('saving').html(data.template);
              controller._adjustMobileSignature();
            }

            controller._reloadPreview($('#form-group-profile-picture .image-preview'), data.form.profile_picture_url);
            controller._reloadPreview($('#form-group-company-logo .image-preview'), data.form.company_logo_url);
          }
        },
        error: function (data) {

        }
      })
    },
    _reloadPreview: function ($previewContainer, url) {
      if (url == null) return;

      var $img = $previewContainer.find('img');

      if ($img.length) {
        $img.attr('src', url);
      } else {
        $(`<img src="${url}"/>`).appendTo($previewContainer);
      }
    }
  });

  return WelcomeEmailSignatureBuilderController;

})(appCustomerSpace.Controllers.Public.MainController);
